import { createRouter, createWebHistory } from 'vue-router'

import store from '@/store'
import { getToken } from '@/utilities/auth' // get token from cookie
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import BlankLayout from '@/layouts/guest/BlankLayout.vue'
import HorizontalLayout from '@/layouts/menu-styles/HorizontalLayout.vue'

const simpleAuthchildRoutes = (prefix) => [
  {
    path: 'login',
    name: prefix + '.login',
    meta: { auth: false, name: 'Login' },
    component: () => import('@/views/auth/default/SignIn.vue')
  },
  {
    path: 'register',
    name: prefix + '.register',
    meta: { auth: false, name: 'Register' },
    component: () => import('@/views/auth/default/SignUp.vue')
  }
]

// Dashboard routes
const dashboardRoutes = () => [
  {
    path: '',
    name: 'home',
    meta: {
      auth: true,
      title: 'Página Inicial',
      isBanner: false,
      roles: []
    },
    component: () => import('@/views/modules/registrations/MachanePage.vue')
  }
]
const landingPageRoutes = (prefix) => [
  {
    path: '',
    name: prefix + '.settings',
    meta: {
      auth: false,
      title: 'Minha Conta',
      roles: []
    },
    hidden: true,
    component: () => import('@/views/modules/kf-advogados/HomePage.vue')
  }
]

const errorRoutes = (prefix) => [
  // Error Pages
  {
    path: '404',
    name: prefix + '.404',
    meta: { auth: true, name: 'Error 404', isBanner: true },
    component: () => import('@/views/errors/Error404Page.vue')
  },
  {
    path: '500',
    name: prefix + '.500',
    meta: { auth: true, name: 'Error 500', isBanner: true },
    component: () => import('@/views/errors/Error500Page.vue')
  },
  {
    path: 'maintenance',
    name: prefix + '.maintenance',
    meta: { auth: true, name: 'Maintenance', isBanner: true },
    component: () => import('@/views/errors/MaintenancePage.vue')
  }
]

export const constantRoutes = [
  {
    path: '/',
    name: 'landing-page',
    component: HorizontalLayout,
    children: landingPageRoutes('landing-page'),
    hidden: false
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: HorizontalLayout,
    hidden: false,
    children: dashboardRoutes('default')
  },
  {
    path: '/auth',
    name: 'auth',
    hidden: true,
    component: HorizontalLayout,
    children: simpleAuthchildRoutes('auth')
  },
  // Errors Pages
  {
    path: '/errors',
    name: 'errors',
    hidden: true,
    component: () => BlankLayout,
    children: errorRoutes('errors')
  },
  // ...registrations,
]

export const asyncRoutes = []

const router = createRouter({
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes: constantRoutes
})

router.beforeEach(async (to, from, next) => {
  try {
    const hasToken = getToken()
    const authRequired = to.meta.auth
    if (authRequired && !hasToken) {
      next({ name: 'auth.login' })
    }
    const hasRoles = store.getters.roles && store.getters.roles.length > 0
    if (hasToken && !hasRoles) {
      const { roles } = await store.dispatch('user/getInfo')
      const accessRoutes = await store.dispatch('permissions/generateRoutes', roles)
      accessRoutes.forEach((route) => {
        router.addRoute(route)
      })
      next({ ...to, replace: true })
    } else {
      next()
    }
  } catch (error) {
    console.error('Error during navigation:', error)
    next(error)
  }
})

export default router
